export default "/_next/static/images/service-premium-2x-e8221c9ed6cb03ee5bd1aef76d2346aa.png";